


























import { Component, Vue } from "vue-property-decorator";
import SubmissionForm from "./components/SubmissionForm.vue";
import Offer from "./models/Offer";
import OffersAPI from "./services/OffersAPI";

@Component({
  components: {
    SubmissionForm
  }
})
export default class App extends Vue {
  loading: boolean = false;
  offer: Offer = new Offer();
  offerId: string = "";
  requestId: string = "";
  error: boolean = false;
  errorMessage: string = "";
  currentTime: Date = new Date();

  async created() {
    this.loading = true;

    this.getQueryParams();
    if (!this.error) {
      await this.getOfferInfo();
    }

    this.loading = false;
  }

  async getOfferInfo(): Promise<void> {
    try {
      const response = await OffersAPI.getOffer(this.offerId, this.requestId);
      this.offer = response;

      if (this.offer.offerDetails.expiresDate < this.currentTime) {
        this.error = true;
        this.errorMessage = "Czas na składanie zapytań minął";
      }
    } catch (error) {
      console.error(error);
      this.error = true;
      this.errorMessage = "Błąd połączenia z serwerem";
    }
  }

  getQueryParams(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const offerIdParam = urlParams.get("offerId");
    const requestIdParam = urlParams.get("requestId");
    if (offerIdParam && requestIdParam) {
      this.offerId = offerIdParam;
      this.requestId = requestIdParam;
    } else {
      this.error = true;
      this.errorMessage = "Nieprawidłowe parametry zapytania";
      console.error("Invalid params");
    }
  }
}
